<template>
    <footer>
        <div class="container">
            <p class="copyrightText">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">皖ICP备16016415号</a><br>
            <span>fishros.com | 鱼香ROS</span><br>
            <span>杭州鱼香机器人科技有限公司</span><br>
            <span>Copyright © 2021-{{ year }} FishROS. All rights reserved.</span>
            </p>
        </div>
    </footer>
</template>

<script>
export default {
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
    footer{
        background-color: #fff;
        width: 100%;
        margin-bottom: 0;
        padding: 8px 0;
        box-sizing: border-box;
    }
    .container {
        position: relative;
        height: 92px;
        max-width: 1180px;
        margin: 0 auto;
    }
    .copyrightText{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: #ccc;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
}

    /* 备案号按工信部要求必须是可点击链接，跳转到 beian.miit.gov.cn */
    .copyrightText a {
        color: #bbb;
        text-decoration: none;
    }

    .copyrightText a:hover {
        color: #999;
        text-decoration: underline;
    }
</style>
